import React from "react"
import { graphql, Link } from 'gatsby'
import Seo from '../components/seo'
import BlogList from '../components/blog-list'
import { Footer } from '../components/footer'
import { Header } from '../components/header'
import logoGreen from '../../static/images/evitat-logo-green.png'
import "../styles/index.scss"
// import logoGreen from "../../static/images/evitat-logo-green.png";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFacebook, faLinkedin, faTwitter} from '@fortawesome/free-brands-svg-icons';
import { useHeroContentQuery } from "../components/home/home-hero-content"
export const query = graphql`
    query($categorySlug: String!) {
        contentfulBlogCategories(categorySlug: {eq: $categorySlug}) {
            categoryName
        }
        site {
            siteMetadata {
                title
                description
                author
                siteUrl
            }
        }
    }
`

const BlogCategory = ({data}) => {
    const category = data.contentfulBlogCategories;
    const site = data.site;
    const fbUrlToShare = `http://www.facebook.com/share.php?u=${site.siteMetadata.siteUrl}/${category.categorySlug}&title=${category.categoryName}`;
    const twitterUrlToShare = `http://twitter.com/intent/tweet?url=${site.siteMetadata.siteUrl}/${category.slug}`;
    const linkedInUrlToShare = `http://www.linkedin.com/shareArticle?mini=true&url=${site.siteMetadata.siteUrl}/${category.slug}`;
    const categoryDescription = `Evitat blog category: ${category.categoryName} posts`;
    const homePage = useHeroContentQuery().contentfulPage;
    return (
        <div className="container">
            <Seo 
                title={category.categoryName} 
                slug={category.categorySlug} 
                description={categoryDescription} 
                socialMediaShareImg={logoGreen}
                isPost/>
            <Header />
            <main>
                <section className="section-about category" style={{
                    backgroundImage: `url(${homePage?.heroImage?.file.url})`,
                }}>
                    <div className="section-about-container">
                        <h1 className="section-about__heading">
                            <span className="section-about__heading--main">Category: {category.categoryName} </span>
                        </h1>
                    
                    </div>
                </section>
                <BlogList category={category.categoryName} />
            </main>
            <Footer/>
        </div>
    )
}


export default BlogCategory
